import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectActionsInStore,
  selectActionsPageLoading,
  selectActionsShowInitWaitingMessage,
} from '../_selectors/action.selectors';

export class ActionsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectActionsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectActionsShowInitWaitingMessage));

    this.store.pipe(select(selectActionsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
